import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentDataModel } from '../../../../models/document/document-data.model';
import { FileManagerService } from '../../../../modules/file-manager/file-manager.service';
import { PanZoomAPI, PanZoomConfig } from 'ngx-panzoom';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';
import { DocumentFileTypeEnum } from '../../../../models/enum/document/document-file-type.enum';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tdo-organizer-slideshow-dialog',
  templateUrl: './tdo-organizer-slideshow-dialog.component.html',
  styleUrls: ['./tdo-organizer-slideshow-dialog.component.scss']
})
export class TdoOrganizerSlideshowDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('dragArea') dragAreaRef: ElementRef<HTMLDivElement>;
  @ViewChild('draggableImage') imageRef: ElementRef<HTMLImageElement>;

  panZoomConfig: PanZoomConfig = new PanZoomConfig();
  private panZoomAPI: PanZoomAPI;
  private apiSubscription: Subscription;
  private pdf: PDFDocumentProxy;
  currentDocument: DocumentDataModel;

  parentIds: string[];
  originals: DocumentDataModel[];
  index = 0;
  isPanEnabled = true;
  isFitToScreen = true;
  imageScale = 1.0;
  isChanging = true;
  isShowImage = false;
  x = 0;
  y = 0;
  pdfPageNum = 1;
  totalPdfPages = 0;
  isZoomApiReady = false;
  isSafeUrlRetrieved = false;
  currentDocumentURL: string;

  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    switch (event.key) {
      case 'ArrowRight':
        if (event.ctrlKey) {
          this.onGotoEnd();
        } else {
          this.onNext();
        }
        break;
      case 'ArrowLeft':
        if (event.ctrlKey) {
          this.onGotoStart();
        } else {
          this.onPrevious();
        }
        break;
    }
  }

  constructor(@Inject(MAT_DIALOG_DATA) data,
    private readonly cd: ChangeDetectorRef,
    private readonly domSanitizer: DomSanitizer,
    private readonly fileManagerService: FileManagerService,
    private readonly dialogRef: MatDialogRef<TdoOrganizerSlideshowDialogComponent>,
    private readonly toastr: ToastrService,) {
    this.parentIds = data as string[];
  }

  displayMessage(message, type = '') {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else if (type.toLowerCase() === "warning")
      this.toastr.warning(message, null, { timeOut: 7000 });
    else
      this.toastr.success(message, null, { timeOut: 7000 });
  }

  ngAfterViewInit() {
    console.log("TdoOrganizerSlideshowDialogComponent ngAfterViewInit");
    this.panZoomConfig = new PanZoomConfig();
    this.apiSubscription = this.panZoomConfig.api.subscribe((api: PanZoomAPI) => {
      if (!api.model) {
        return;
      }
      this.panZoomConfig.zoomStepDuration = 0.0;
      this.panZoomConfig.acceleratePan = false;
      this.panZoomConfig.panOnClickDrag = this.isPanEnabled;
      this.panZoomConfig.freeMouseWheel = true;
      this.panZoomConfig.freeMouseWheelFactor = 0.001;
      this.panZoomAPI = api;
      this.isZoomApiReady = true;
      setTimeout(() => {
        this.panZoomAPI.detectContentDimensions();
        this.panZoomAPI.centerContent(0.0);
      }, 400);
    });
    console.log('TdoOrganizerSlideshowDialogComponent parentIds', this.parentIds);
    if (this.parentIds.length > 0) {
      this.fileManagerService.getDocuments(this.parentIds).subscribe((parentDocs) => {
        this.originals = [];
        for (const id of this.parentIds) {
          const mod = parentDocs.find(p => p.DocumentID === id);
          this.originals.push(mod);
        }
        this.currentDocument = this.originals[this.index];
        this.currentDocumentURL = this.getDocumentUrl();
        this.isChanging = false;
      });
    }
    this.cd.markForCheck();    
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
  }

  getDocumentUrl() {
    console.log('getDocumentUrl this.originals: ', this.originals, this.index);
    console.log('getDocumentUrl this.index: ', this.index);
    if (!this.originals) {
      return '';
    }
    const url = this.fileManagerService.getDocumentUrlFromDocument(this.originals[this.index]);
    console.log('getDocumentUrl result', url);
    return url;
  }

  onPanOptionChange($event: MatCheckboxChange) {
    this.panZoomConfig.panOnClickDrag = this.isPanEnabled;
  }

  onFitToScreenOptionChange(event: MatCheckboxChange) {
    this.setReady();
  }

  onReset() {
    const bound = this.dragAreaRef.nativeElement.getBoundingClientRect();
    const rec = {
      x: bound.x,
      y: bound.y,
      width: bound.width,
      height: bound.height
    };

    setTimeout(() => {
      this.panZoomAPI.detectContentDimensions();
      this.panZoomAPI.centerContent(0.0);
    }, 200);
  }

  onNext() {
    if (this.index < this.originals?.length - 1) {
      this.index++;
      console.log('Filetype: ' + this.originals[this.index].enumDocumentFileTypeID);
      this.currentDocument = this.originals[this.index];
      this.currentDocumentURL = this.getDocumentUrl();
      this.isSafeUrlRetrieved = false;
      this.setReady();
    }
  }

  onPrevious() {
    if (this.index > 0) {
      this.index--;
      this.currentDocument = this.originals[this.index];
      this.currentDocumentURL = this.getDocumentUrl();
      this.isSafeUrlRetrieved = false;
      this.setReady();
    }
  }

  onGotoEnd() {
    this.index = this.originals.length - 1;
    this.currentDocument = this.originals[this.index];
    this.currentDocumentURL = this.getDocumentUrl();
    this.setReady();
    this.cd.markForCheck();
  }

  onGotoStart() {
    this.index = 0;
    this.currentDocument = this.originals[this.index];
    this.currentDocumentURL = this.getDocumentUrl();
    this.setReady();
    this.cd.markForCheck();
  }

  get isImage() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.JPG;
    } else {
      return false;
    }
  }

  get isPdf() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.PDF;
    } else {
      return false;
    }
  }

  get isPowerPoint() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.PowerPoint;
    } else {
      return false;
    }
  }

  get isXML() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.XML;
    } else {
      return false;
    }
  }

  get isJSON() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.JSON;
    } else {
      return false;
    }
  }

  get isExcel() {
    if (this.originals) {
      return this.originals[this.index].enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.Excel;
    } else {
      return false;
    }
  }

  get isMovie() {
    if (this.originals) {
      const doc = this.originals[this.index];
      return doc.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.MP4 ||
        doc.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.AVI;
    } else {
      return false;
    }
  }

  get isAudio() {
    if (this.originals) {
      const doc = this.originals[this.index];
      return doc.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.MP3 ||
        doc.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.WAV;
    } else {
      return false;
    }
  }

  setReady() {
    console.log('setReady');
    this.isShowImage = false;
    this.isChanging = true;
    setTimeout(() => {
      this.isChanging = false;
      this.cd.markForCheck();
    }, 200);
  }

  onImageLoaded() {
    const bound = this.imageRef.nativeElement.getBoundingClientRect();
    const rec = {
      x: bound.x,
      y: bound.y,
      width: bound.width,
      height: bound.height
    };

    this.panZoomAPI.detectContentDimensions();
    this.panZoomAPI.updateContentDimensions(rec.width, rec.height);
    if (this.isFitToScreen) {
      this.panZoomAPI.zoomToFit(rec, 0.0);
    }
    this.panZoomAPI.centerContent(0.0);
    setTimeout(() => {
      this.isShowImage = true;
    }, 200);
  }

  onClose() {
    this.dialogRef.close();
  }

  onPrint() {
    this.pdf.getData().then((u8) => {
      let blob = new Blob([u8.buffer], {
        type: 'application/pdf'
      });

      const blobUrl = window.URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      window.URL.revokeObjectURL(blobUrl);
    });
  }

  onDownload() {

    this.pdf.getData().then((u8) => {
      let blob = new Blob([u8.buffer], {
        type: 'unknown' //application/octet-stream
      });

      const blobUrl = window.URL.createObjectURL(blob);
      const aLink = document.createElement('a');
      aLink.style.display = 'none';
      aLink.download = this.currentDocument.PhysicalFileName;
      aLink.href = blobUrl;
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      window.URL.revokeObjectURL(blobUrl);
      this.displayMessage(`File ${this.currentDocument.PhysicalFileName} downloaded.`)
    });
  }

  onPreviousPdfPage() {
    if (this.pdfPageNum > 1) {
      this.pdfPageNum--;
    }
  }

  pdfZoomOut() {
    if (this.imageScale > 0.2)
      this.imageScale -= .1;
  }

  pdfZoomIn() {
    if (this.imageScale < 5)
      this.imageScale += .1;
  }

  pdfZoomReset() {
    this.imageScale = 1.0;
  }

  onNextPdfPage() {
    if (this.pdfPageNum < this.totalPdfPages) {
      this.pdfPageNum++;
    }
  }

  onAfterPdfLoaded(event: PDFDocumentProxy) {
    this.totalPdfPages = event.numPages;
    this.pdf = event;

  }

  getSafeUrl() {
    if (this.isSafeUrlRetrieved) {
      return;
    }

    if (!this.originals) {
      return '';
    }
    const ur = this.fileManagerService.getDocumentUrlFromDocument(this.originals[this.index]);
    this.isSafeUrlRetrieved = true;
    return this.domSanitizer.bypassSecurityTrustResourceUrl('https://docs.google.com/gview?url=' + ur + '&embedded=true');
  }
}
